// extracted by mini-css-extract-plugin
export default {"table":"MissedRevenueTable_table__in4LK"};